import React from 'react';
import { Card, Col, Row } from "react-bootstrap"

export const CardSkewShadow = (props) => {

  return (
    <Card className={props.bg}>
      <Card.Body className='skew-shadow'>
        {props.children}
      </Card.Body>
    </Card>
  )
}

export const CardStats = (props) => {
  return (
    <Card className={`card-stats ${props.cardType}`} onClick={props.goTo} style={{marginBottom: '15px'}}>
      <Card.Body className='text-center'>
        {props.children}
      </Card.Body>
    </Card>
  )
}
